export default __webpack_public_path__ + "static/media/106226027_3673820899298012_4165228408522325438_n.af8bcde5.jpg";